/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Subtract_Frame_From_StartInputs */



/**
* | output |
* | --- |
* | "Decrease start time by one frame" |
*
* @param {Shortcut_Keys_Desc_Subtract_Frame_From_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_subtract_frame_from_start = /** @type {((inputs?: Shortcut_Keys_Desc_Subtract_Frame_From_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Subtract_Frame_From_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Diminuer le temps de debut d'une image")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verringere die Startzeit um ein Frame")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riduci l'ora di inizio di un fotogramma")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Уменьшите время начала на один кадр.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Disminuir el tiempo de inicio en un cuadro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("减少一帧的起始时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始時間を1フレーム減らす")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रारंभ समय को एक फ्रेम से घटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Diminua o tempo de início em um quadro.")
	return /** @type {LocalizedString} */ ("Decrease start time by one frame")
});